import { createContext } from 'react';

import { HistogramChartConfiguration } from '../types/histogram.js';

export const HistogramInteractionsContext = createContext<
  NonNullable<HistogramChartConfiguration['interactions']>
>({});
